import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HalResource, HalResourceService, INIT_BY_JSON_2_TS} from '@drklein-pk/tng-angular-common';
import {Observable} from 'rxjs';
import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('ProductFormResource')
export class ProductFormResource extends HalResource {
  @JsonProperty('id', String)
  id: string = INIT_BY_JSON_2_TS;

  get productId(): string | undefined {
    return this._embedded?.product?.id;
  }

  get platformProductId(): string | undefined {
    return this._embedded?.product?._embedded?.platformProduct?.id;
  }
}

@Injectable()
export class ProductFormsService extends HalResourceService<ProductFormResource> {
  constructor(httpClient: HttpClient) {
    super('productForms', httpClient, ProductFormResource, '/api/leadsourceservice/v1');
  }

  getProductForms(leadSourceId: string): Observable<ProductFormResource[]> {
    return this.findAll(`/lead-sources/${leadSourceId}/product-forms`);
  }
}
